import React, { useCallback } from "react";
import useRootTranslation from "../../../../../hooks/use-root-translation";
import { TableRow } from "../../index.styled";
import HeadFilterCell from "../header-cell-filter";
import { HeadCell } from "./index.styled";
import HomeDashboardPageQuery from "../../../../../models/home-dashboard-page-query.model";
import useUmamiTracking from "../../../../../hooks/use-umami-tracking";
import { Events } from "../../../../../utils/constants";
import { useSelector } from "react-redux";

export interface HeaderItemFilter {
  value: string;
  label: string | JSX.Element;
}

export interface HeaderItemOrderBy {
  value: "performance" | "resume" | "createdByAsc" | "createdByDesc" | string[];
  label: string | JSX.Element;
}

export interface HeaderItem {
  value: string;
  width?: string;
  query_param?:
    | "process_status"
    | "offer_status"
    | "completed_range"
    | "orderBy";
  filter?: HeaderItemFilter[];
  orderBy?: HeaderItemOrderBy[];
}

interface HeaderProps {
  headerItems: HeaderItem[];
  handleSearch?: (query: HomeDashboardPageQuery) => void;
}
const Header: React.FC<HeaderProps> = ({ headerItems, handleSearch }) => {
  const { root } = useRootTranslation(
    "ranking-table.headers",
    "private-home-page"
  );
  const pushUmami = useUmamiTracking();

  const user = useSelector((state: any) => state.authState.user);

  const getHeadCell = useCallback(
    (item: HeaderItem, index: number) => {
      const events = {
        process_status: Events.SELECT_PROCESS_FILTER_BY_FEEDBACK,
        offer_status: Events.SELECT_PROCESS_FILTER_BY_STATUS,
        completed_range: "",
        orderBy: "",
      };
      if (
        (!!item.filter && item.filter.length > 0) ||
        (!!item.orderBy && item.orderBy.length > 0)
      ) {
        return (
          <HeadFilterCell
            item={item}
            key={`header-item-${index}`}
            handleSearch={handleSearch}
            onClick={() => {
              const actualEvent = events[item.query_param ?? "process_status"];
              if (actualEvent === "") return;
              pushUmami(actualEvent, {filters: item.filter?.map(f => f.value)}, user);
            }}
          />
        );
      }
      return (
        <HeadCell width={item.width} key={`header-item-${index}`}>
          {root(item.value)}
        </HeadCell>
      );
    },
    [root, handleSearch, pushUmami, user]
  );

  return (
    <TableRow>
      {headerItems.map((item, index) => getHeadCell(item, index))}
    </TableRow>
  );
};

export default Header;
